import {
  AnyAction,
  createAsyncThunk,
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";
import {
  GetReportById,
  GetReports,
  SaveReport,
  ViewReportUpdation,
} from "./reports.request";
import {
  setLeadExistData,
  setToastNotification,
} from "../../../../components/ToastNotification/service/toastNotificationSlice";
import { ReportsInitialStateDTO } from "./types";

export const initialState: ReportsInitialStateDTO = {
  reportData: null,
  reportWholeData: null,
  reportById: null,
  success: false,
  error: false,
  loading: false,
  viewReportSuccess: false,
  viewReportError: false,
  viewReportLoading: false,
  reportDataloading: false,
  saveReportLoading: false,
  saveReportSuccess: false,
  reportByIdLoading: false,
};

export const getReports = createAsyncThunk(
  "reports/getReports",
  async (body: any, thunkAPI: any) => {
    return GetReports(body)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        throw e.response.data;
      });
  }
);

export const viewReports = createAsyncThunk(
  "reports/viewReports",
  async (id: string, thunkAPI: any) => {
    return ViewReportUpdation(id)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        throw e.response.data;
      });
  }
);

export const getReportData = createAsyncThunk(
  "reports/getReportData",
  async (body: any, thunkAPI: any) => {
    return GetReports(body)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        throw e.response.data;
      });
  }
);

export const saveReport = createAsyncThunk(
  "reports/saveReport",
  async (body: any, thunkAPI: any) => {
    return SaveReport(body)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const getReportById = createAsyncThunk(
  "reports/getReportById",
  async (id: string, thunkAPI: any) => {
    return GetReportById(id)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        throw e.response.data;
      });
  }
);

export const reportSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    reset: () => initialState,
    resetReportStatuses: (state) => {
      state.saveReportSuccess = false;
    },
    resetWholeReportData: (state) => {
      state.reportWholeData = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getReports.pending, (state) => {
      state.loading = true;
      state.success = false;
      state.error = false;
    });
    builder.addCase(
      getReports.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.success = true;
        state.error = false;
        state.reportData = action?.payload;
      }
    );
    builder.addCase(getReports.rejected, (state, action: AnyAction) => {
      state.loading = false;
      state.success = false;
      state.error = action?.error?.message || "Something went wrong";
    });
    builder.addCase(viewReports.pending, (state) => {
      state.viewReportLoading = true;
      state.viewReportSuccess = false;
      state.viewReportError = false;
    });
    builder.addCase(
      viewReports.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.viewReportLoading = false;
        state.viewReportSuccess = true;
        state.viewReportError = false;
      }
    );
    builder.addCase(viewReports.rejected, (state, action: AnyAction) => {
      state.viewReportLoading = false;
      state.viewReportSuccess = false;
      state.viewReportError = action?.error?.message || "Something went wrong";
    });
    builder.addCase(getReportData.pending, (state) => {
      state.reportDataloading = true;
      state.success = false;
      state.error = false;
    });
    builder.addCase(
      getReportData.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.reportDataloading = false;
        state.success = true;
        state.error = false;
        state.reportWholeData = action?.payload;
      }
    );
    builder.addCase(getReportData.rejected, (state, action: AnyAction) => {
      state.reportDataloading = false;
      state.success = false;
      state.error = action?.error?.message || "Something went wrong";
    });
    builder.addCase(saveReport.pending, (state) => {
      state.saveReportLoading = true;
      state.saveReportSuccess = false;
      state.error = false;
    });
    builder.addCase(
      saveReport.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.saveReportLoading = false;
        state.saveReportSuccess = action?.payload?.message || "Report Created";
        state.error = false;
      }
    );
    builder.addCase(saveReport.rejected, (state, action: AnyAction) => {
      state.saveReportLoading = false;
      state.saveReportSuccess = false;
      state.error = action?.error?.message || "Something went wrong";
    });
    builder.addCase(getReportById.pending, (state) => {
      state.reportByIdLoading = true;
      state.success = false;
      state.error = false;
    });
    builder.addCase(
      getReportById.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.reportByIdLoading = false;
        state.success = true;
        state.error = false;
        state.reportById = action?.payload;
      }
    );
    builder.addCase(getReportById.rejected, (state, action: AnyAction) => {
      state.reportByIdLoading = false;
      state.success = false;
      state.error = action?.error?.message || "Something went wrong";
    });
  },
});

export default reportSlice.reducer;
export const { reset, resetReportStatuses, resetWholeReportData } =
  reportSlice.actions;
